import { render, staticRenderFns } from "./ShipmentDetails.vue?vue&type=template&id=7cbfa9f3&"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports